import { Box, Grid, Stack, Typography } from '@mui/material';
import { ReactComponent as TotalSent } from 'assets/images/external-totalsent.svg';
import { ReactComponent as Pending } from 'assets/images/external-pending.svg';
import { ReactComponent as InProgress } from 'assets/images/external-inprogress.svg';
import { ReactComponent as Completed } from 'assets/images/external-completed.svg';
import { ReactComponent as Average } from 'assets/images/external-avg.svg';

interface RiskAssessmentsProps {
  totalAssessments: number;
  completedStatus: number;
  inProgress: number;
  pendingStatus: number;
}

const RiskAssessmentsStatus: React.FC<RiskAssessmentsProps> = (props) => {
  const { totalAssessments, completedStatus, inProgress, pendingStatus } =
    props;
  return (
    <Grid
      container
      columnGap={2}
      rowGap={2}
      className="risk-assessments-container"
    >
      <Grid item xs>
        <Stack
          direction="row"
          sx={{
            alignItems: 'center',
            justifyContent: 'unset !important',
            gap: '0.5rem',
          }}
        >
          <TotalSent />
          <Box>
            <Typography component="span">Total Sent</Typography>
            <Typography variant="body1" mt={3}>
              {totalAssessments}
            </Typography>
          </Box>
        </Stack>
      </Grid>
      <Grid item xs>
        <Stack
          direction="row"
          sx={{
            alignItems: 'center',
            justifyContent: 'unset !important',
            gap: '0.5rem',
          }}
        >
          <Pending />
          <Box>
            <Typography component="span">Pending</Typography>
            <Typography variant="body1" mt={3}>
              {pendingStatus}
            </Typography>
          </Box>
        </Stack>
      </Grid>
      <Grid item xs>
        <Stack
          direction="row"
          sx={{
            alignItems: 'center',
            justifyContent: 'unset !important',
            gap: '0.5rem',
          }}
        >
          <InProgress />
          <Box>
            <Typography component="span">In Progress</Typography>
            <Typography variant="body1" mt={3}>
              {inProgress}
            </Typography>
          </Box>
        </Stack>
      </Grid>
      <Grid item xs>
        <Stack
          direction="row"
          sx={{
            alignItems: 'center',
            justifyContent: 'unset !important',
            gap: '0.5rem',
          }}
        >
          <Completed />
          <Box>
            <Typography component="span">Completed </Typography>
            <Typography variant="body1" mt={3}>
              {completedStatus}
            </Typography>
          </Box>
        </Stack>
      </Grid>
      {completedStatus > 0 && (
        <Grid item xs>
          <Stack
            direction="row"
            sx={{
              alignItems: 'center',
              justifyContent: 'unset !important',
              gap: '0.5rem',
            }}
          >
            <Average />
            <Box>
              <Typography component="span">Avg. Completion</Typography>
              <Typography variant="body1" mt={3}>
                {parseInt(`${(completedStatus / totalAssessments) * 100}`, 10)}%
              </Typography>
            </Box>
          </Stack>
        </Grid>
      )}
    </Grid>
  );
};

export default RiskAssessmentsStatus;
